import React from 'react'

export default ({text, position, size = 'large'}) => (
  <span data-balloon={text} data-balloon-pos={position} data-balloon-length={size}>
    <i className="fa fa-info-circle fa-lg"/>
  </span>
)
